import * as moment from 'moment';

export class FreeTrialSignup {
    constructor(
        public userInfo: UserInfo,
        public schoolInfo: SchoolInfo,
        public paymentInfo: PaymentInfo,
        public leadID: string,
    ) {}
}

export class PaymentInfo {
    constructor(
        public fName: string,
        public lName: string,
        public cardNumber: string,
        public cvv: string,
        public zip: string,
        public expDate: Date,
        public token: string,
    ) { }

    getPayerName() {
        return this.fName + " " + this.lName;
    }

    static getExpirationFromMoAndYr(month: string, year: string) {
        return new Date(Number(year), Number(month)-1);
    }

    static getExpirationStrFromDate(expDate: Date) {
        return moment(expDate).format('MM') + " / " + moment(expDate).format('YY');
    }

    static hasChanged(p1: PaymentInfo, p2: PaymentInfo): boolean {
        if (p1.fName !== p2.fName)
            return true;

        if (p1.lName !== p2.lName)
            return true;

        if (p1.cardNumber !== p2.cardNumber)
            return true;

        if (p1.cvv !== p2.cvv)
            return true;

        if (p1.zip !== p2.zip)
            return true;

        if (!moment(p1.expDate).isSame(moment(p2.expDate)))
            return true;

        return false;
    }
}

export class UserInfo {
	constructor(
		public fName: string,
		public lName: string,
		public password: string,
		public email: string,
        public uid: string,
        public emailVerified: boolean
    ) { }
    
    getName(): string {
        return this.fName + " " + this.lName; 
    }
}

export class SchoolInfo {
    constructor(
		public schoolName: string,
		public phoneNumber: string,
		public address: string,
		public city: string,
        public state: string,
        public zip: string,
        public alias: string,
        public accountNumber?: string,
        public generatedAliases?: string[]
    ) { }

    // Returns the url of the school
    getURL() {
        if (!this.alias)
            return '';
        return `https://${this.alias}.childpilot.com`;
    }

    // Generates and alias using the number of tries as a parameter
    generateAlias(tryNum: number): string {
        if (!this.schoolName)
            return;

        // Trim values for School Name and City. Replace special chars and apostrophes
        let noSpecialCharsName = this.schoolName.replace(/[^\w\s]/gi, '').replace(/'/g,'');
        let trimmedName = noSpecialCharsName.trim();
        let noSpecialCharsCity = this.city.replace(/[^\w\s]/gi, '').replace(/'/g,'');
        let trimmedCity = noSpecialCharsCity.trim();

        try {
            let nameArr: string[] = trimmedName.split(' ');
            let alias = "";

            if (nameArr.length > 1) {
                switch(tryNum) {
                    case 1: {
                        alias =this.wordThenCharacters(nameArr);
                        break;
                    }
                    case 2: {
                        alias = this.characters(nameArr);
                        break;
                    }
                    case 3: {
                        alias = this.charactersThenWord(nameArr);
                        break;
                    }
                    case 4: {
                        alias = this.charactersThenWord(nameArr) + trimmedCity;
                        break;
                    }
                    case 5: {
                        alias = this.wordThenCharacters(nameArr) + trimmedCity;
                        break;
                    }
                    case 6: {
                        alias = this.characters(nameArr) + trimmedCity;
                        break;
                    }
                }
            }
            else {
                switch (tryNum) {
                    case 1: {
                        alias += trimmedName;
                        break;
                    }
                    case 2: {
                        alias += trimmedName + trimmedCity;
                        break;
                    }
                    case 3: {
                        alias += trimmedCity + trimmedName;
                        break;
                    }
                    default: {
                        alias += "";
                        break;
                    }
                }
            }
                

            return alias.toLowerCase();
        }
        catch(e) {
            console.log(e);
            return "";
        }
    }

    // use first letter of every word until the last word
    // E.g. 'At Worlds End' -> awend
    charactersThenWord(nameArr: string[]): string {
        let alias = "";
        let lastIndex: number = nameArr.length -1;

        let i = 0; 
        while (i != lastIndex) {
            alias += nameArr[i] ? nameArr[i][0]: '';
            i++;
        }

        alias += nameArr[lastIndex] ? nameArr[lastIndex]: '';

        return alias;
    }
    
    // Leave first whole word, then use the first letter of every word
    // E.g. 'At Worlds End' -> atwe
    wordThenCharacters(nameArr: string[]): string {
        let alias = "";
        
        for (let j = 0; j < nameArr.length; j++) {
            const element = nameArr[j];
            
            if (j == 0)
                alias += element ? element: '';
            else   
                alias += element[0] ? element[0]: '';
        }

        return alias;
    }

    // Put all words together
    // E.g. 'At Worlds End' -> atworldsend
    characters(nameArr: string[]): string {
        return nameArr.join('');
    }
    
    static hasChanged(s1: SchoolInfo, s2: SchoolInfo): boolean {
        if (s1.schoolName !== s2.schoolName)
            return true;

        // if (s1.phoneNumber !== s2.phoneNumber)
        //     return true;

        if (s1.address !== s2.address)
            return true;

        if (s1.city !== s2.city)
            return true;

        if (s1.state !== s2.state)
            return true;

        if (s1.zip !== s2.zip)
            return true;

        if (s1.alias !== s2.alias)
            return true;

        return false;
    }
}